import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

import { history } from '../../../../../../_helpers/history';
import { alertActions } from '../../../../../../_actions/alert.actions';
import { saveQuestion, cancelQuestion, cancelEdit, setPromptWarning } from '../../../../../../_actions/question-library.action';
import { questionLibraryService } from '../../../../../../_services/question-library.service';

const Card = ({ dispatch, question, isSaving, currentId, children }) => {
  const [show, setShow] = useState(false);
  const [request, setRequest] = useState(false);
  const [applyAll, setApplyAll] = useState(false);

  const handleClose = () => { setShow(false); }
  const handleShow = () => { setShow(true); }

  return (
    <div className="card mb-2 border-light">
      <div className="card-body">
        {children}
      </div>

      <div className="card-footer">
        <button type="button"
          disabled={isSaving}
          onClick={(e) => {
            if (!currentId) {
              dispatch(saveQuestion())
            } else {
              handleShow()
            }
          }} className="btn btn-primary float-left">
          {currentId &&
            <small>{isSaving ? 'Updating...' : 'Update'}</small>
          }

          {!currentId &&
            <small>{isSaving ? 'Saving...' : 'Save'}</small>
          }
        </button>
        <button onClick={(e) => {
          if (currentId) {
            dispatch(cancelEdit())
              .then(() => {
                history.push('/questions');
              });
          } else {
            dispatch(cancelQuestion(question));
          }
        }} type="button" className="btn btn-outline-secondary float-right">
          <small>Cancel</small>
        </button>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Apply question changes to existing questionnaires?</p>

          <div className="custom-control custom-switch">
            <input
              onChange={(e) => { setApplyAll(!applyAll) }}
              checked={applyAll}
              id={`id_${currentId}_update`}
              value="note"
              type="checkbox"
              className="custom-control-input" />
            <label
              htmlFor={`id_${currentId}_update`}
              className="custom-control-label">Apply All</label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setRequest(true);
              questionLibraryService.update(currentId, question, applyAll)
                .then(() => {
                  dispatch(setPromptWarning(false))
                    .then(() => {
                      setRequest(false);
                      handleClose();
                      history.push("/questions");
                      dispatch(alertActions.success('Question updated successfully!'));
                    })
                })
                .catch(() => {
                  setRequest(false);
                  handleClose();
                  dispatch(alertActions.error('Could not update question at this time. Please try again later.'));
                });
            }}
            disabled={request}
            variant="primary">
            {request ? 'Updating...' : 'Update'}
          </Button>

          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isSaving: state.questionLibrary.isSaving,
    currentId: state.questionLibrary.currentId
  }
}

export default connect(mapStateToProps)(Card);